import { Routes } from '@angular/router';
import { BuyerLayoutComponent } from './buyer-layout.component';
import { BuyerAuthGuard } from '../buyer-authentication/buyer-guards/buyer-auth.guard';
import { WildcardErrorComponent } from 'src/app/Shared/components/wildcard-error/wildcard-error.component';

export const routes: Routes = [
  {
    path: '',
    component: BuyerLayoutComponent,

    children: [
      {
        path: 'auctions',

        loadChildren: () =>
          import(
            '../../buyer-modules/buyer-auctions/buyer-auctions.routes'
          ).then((r) => r.ROUTES),
      },

      {
        path: 'popular-catalogues',

        loadChildren: () =>
          import(
            '../../buyer-modules/popular-catalogue/popular-catalogue.routes'
          ).then((r) => r.routes),
      },

      {
        path: 'search-results',

        loadChildren: () =>
          import(
            '../../buyer-modules/search-results/search-results.routes'
          ).then((r) => r.routes),
      },

      {
        path: 'account',
        // canActivate: [BuyerAuthGuard],

        loadChildren: () =>
          import('../../buyer-modules/account/account.routes').then(
            (r) => r.routes
          ),
      },
      {
        path: 'sellers',

        loadChildren: () =>
          import('../../buyer-modules/buyer-sellers/buyer-sellers-routes').then(
            (r) => r.routes
          ),
      },
      {
        path: 'exclusive-invitation',
        loadChildren: () =>
          import(
            '../../buyer-modules/exclusive-invitation/exclusive-invitation.routes'
          ).then((r) => r.routes),
      },
      {
        // Public account-deletion request form. Google Play requires this route
        // to be reachable without signing in.
        path: 'delete-account',
        loadChildren: () =>
          import(
            '../../buyer-modules/delete-account/delete-account.routes'
          ).then((r) => r.routes),
      },
      {
        // Privacy policy for the BidXSell Buyer mobile app — linked from the
        // Google Play listing and from the app's Account screen.
        path: 'mobile-privacy',
        loadChildren: () =>
          import(
            '../../buyer-modules/mobile-privacy/mobile-privacy.routes'
          ).then((r) => r.routes),
      },
      {
        path: '**',
        component: WildcardErrorComponent,
      },
    ],
  },
];
